// getMessageBadges.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select message badges by message id
 *
 * This selector is isolated from getMessageData due to getting
 * different array everytime message object changes even badges
 * are still the same.
 *
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - select key.
 * @return {array|null} The selected message badges.
 */
const getMessageBadges = createCachedSelector(
  (state, messageId) => state.getIn(['messages', messageId, 'badges']),
  badges => {
    return badges instanceof Collection ? badges.toJS() : badges;
  }
)((state, messageId) => `${messageId}`);

export default getMessageBadges;
